/* eslint-disable react-hooks/exhaustive-deps */
import '../../styles/pricing-table.scss';
import * as React from 'react';
import { useEffect, useState } from 'react';
import PaymentServices from 'services/payment';
import { useHistory } from 'react-router';
import Cookies from 'js-cookie';
import { STRIPE_PRICE_NAME } from 'constants/common';
import { routers } from 'router/router';
import { 
  PriceSilverPlusMonth, 
  PriceSilverPlusMonthTrial,
  PriceSilverPlusYear,
  PriceSilverPlusYearTrial,
  PriceGoldMonth,
  PriceGoldMonthTrial,
  PriceGoldYear,
  PriceGoldYearTrial
} from './components/StripePrices';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { getAccessToken, getUserId, getUserRole, removeAccessToken, removeUserId } from 'utils/sessionStorage';
import authorizationServices from 'services/authorizationServices';
import { useLocation } from 'react-router-dom';

interface Props {}

/**
 * Define sequential order from lowest to highest tier (1 -> 4) for paid upgrade plans.
 * Monthly and Annual variants share the same weight value to keep track of selection
 * easily when user toggles billing cycles.
 */
const PLAN_IDS = {
  SILVER_PLUS_MONTH: 1,
  SILVER_PLUS_YEAR: 2,
  GOLD_MONTH: 3,
  GOLD_YEAR: 4,
} as const;

const UpgradePlan = (props: Props) => {
  const location = useLocation();
  const [studentEmail, setStudentEmail] = React.useState('');
  const [showTrial, setShowTrial] = React.useState(false);
  const dispatch:any = useAppDispatch();

  let history = useHistory();


  // Initialize selected plan state with Silver Plus Month as default
  const [selectPrice, setSelectPrice] = useState<number>(PLAN_IDS.SILVER_PLUS_MONTH);
  const [showAllPrice, setShowAllPrice] = useState(true);
  const [showMontly, setShowMonthly] = useState(true);
  
  // New state to manage user's active choice for free trial selection
  const [isTrialChecked, setIsTrialChecked] = useState<boolean>(false);

  let userId = getUserId();  
  let token = getAccessToken();
  let isLogin:boolean = token ? true : false;


  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.hash.split('?')[1] || location.search);
    const canceled = searchParams.get('canceled')  || '';
    const isRollback = searchParams.get('rollback') === '1';
  
    if (canceled === 'true' && isRollback ) {
      async function triggerUndo() {
        const rawBackup = sessionStorage.getItem('backup_previous_subscription');
        const previousSubscription = rawBackup ? JSON.parse(rawBackup) : null;
        const cachedCustomerId = sessionStorage.getItem('backup_stripe_customer_id') || '';
        const oldPlanType = previousSubscription?.metadata?.plan_type || 'gradmap_starter';

        try { 
          if (oldPlanType === 'gradmap_starter') {
            await PaymentServices.rollbackStarterSubscription(userId??'', cachedCustomerId);
          }
          else {
            // Restore dynamic paid plan (Silver/Gold) while retaining Trial
            await PaymentServices.rollbackDynamicSubscription({
              studentId: `${userId}`,
              targetCustomerId: cachedCustomerId,
              priceName: oldPlanType,
              oldSubscription: previousSubscription
            });
          }

          // Clean up memory
          sessionStorage.removeItem('backup_previous_subscription');
          sessionStorage.removeItem('backup_stripe_customer_id');
          console.log("Your old service pack has been successfully restored.");

          // /history.push(routers.upgradePlan.path);
          history.replace({
              pathname: routers.upgradePlan.path,
              search: '',
          });
          
          
        } catch (error) {
          console.error("Rollback error:", error);
        } finally {
          // 🌟 IMPORTANT: Clear all data in Storage after processing is complete
          // to clean up memory and prevent this function from being accidentally triggered again if the user reloads the page.
          sessionStorage.removeItem('backup_previous_subscription');
        }
      }
      triggerUndo();
    }
  }, [location]); 

  // Fetch student account information and original account system eligibility[cite: 8]
  useEffect(() => {
    const getInfo = async(studentId:any) => {
      if (isLogin) {
        console.log('run dispatch:');
        const res = await authorizationServices.getStudent(studentId);
        let trial_count = res?.trial_count ?? 0;
        console.log('trial_count:', trial_count);
        // Keep tracking if the account itself is generally banned from trials globally
        setShowTrial(trial_count === 0);
        setIsTrialChecked(trial_count === 0);
        setStudentEmail(res?.email ?? '');
      }
      else {
        handleLogout();
      }

      if (studentId===''){
        history.push(routers.login.path);
      }     
    }

    getInfo(userId);
  }, []);

  React.useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = `document.body.style.overflow = "auto";`;
    document.body?.appendChild(script);
    return () => {
      document.body?.removeChild(script);
    };
  }, []);

  // Action handlers for paid tier selections[cite: 8]
  const onSelectSilverPlusMonth = () => setSelectPrice(PLAN_IDS.SILVER_PLUS_MONTH);
  const onSelectSilverPlusYear = () => setSelectPrice(PLAN_IDS.SILVER_PLUS_YEAR);
  const onSelectGoldMonth = () => setSelectPrice(PLAN_IDS.GOLD_MONTH);
  const onSelectGoldYear = () => setSelectPrice(PLAN_IDS.GOLD_YEAR);

  // Form submission handler to dynamically inject trialDays parameter into Stripe checkout
  const handleSubmit = async (e: any) => {
    e.preventDefault();

    const domainUrl = `${window.location.origin}`;
    let trialDays = 0; 
    let price_Name = '';

    // Check plan choice and explicitly toggle trial settings based on the Checkbox state
    switch(selectPrice) {
      case PLAN_IDS.SILVER_PLUS_MONTH:
        price_Name = STRIPE_PRICE_NAME.SilverPlusMonth
        break;
      case PLAN_IDS.SILVER_PLUS_YEAR:
        price_Name = STRIPE_PRICE_NAME.SilverPlusYear;
        break;
      case  PLAN_IDS.GOLD_MONTH:
        price_Name = STRIPE_PRICE_NAME.GoldMonth;
        break;
      case PLAN_IDS.GOLD_YEAR:
        price_Name = STRIPE_PRICE_NAME.GoldYear;
        break;
    }
    if (isTrialChecked && showTrial) trialDays = 7; 


    if (price_Name) {
      try {

        // Get current subcription - current package information
        if (userId) {
          const subRes:any = await PaymentServices.getSubcription( parseInt(userId ?? ''));
          if (subRes && subRes.data) {
            // 🌟 SAVE TO SESSION STORAGE (convert to JSON string)
            sessionStorage.setItem('backup_previous_subscription', JSON.stringify(subRes.data));


            // 2. 🌟 SAVE CUSTOMER ID TO SESSION STORAGE
            if (subRes.data.customer) {
              sessionStorage.setItem('backup_stripe_customer_id', subRes.data.customer);
            }
          }         
        }

        const customerId = ''; // will retrive from backend
     
        const successUrl = `${domainUrl}/#${routers.upgradePlanSuccess.path}`;
        const cancelUrl =  `${domainUrl}/#${routers.upgradePlan.path}?canceled=true`; 

        console.log('successUrl', successUrl);
        console.log('cancelUrl', cancelUrl);
        sessionStorage.setItem('successUrl',successUrl);
        sessionStorage.setItem('cancelUrl',cancelUrl);
        

        const checkoutUrl = await PaymentServices.createCheckoutSessionUpgrade(
          successUrl,  
          cancelUrl, 
          price_Name, 
          trialDays, userId, 
          studentEmail, customerId
        );
        if (checkoutUrl) {
          window.location.replace(`${checkoutUrl}`);
        } else {
          console.log('Error creating the Checkout Url.');
        }
      } catch(er){
        console.log('Error: ', er);
      }
    }
  };  
  
  const handleLogout = () => {
    if (window.Intercom) window.Intercom('shutdown');
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    Cookies.remove('request_id');
    Cookies.remove('price');
    history.push(routers.login.path);
  };
    
  return (    
    <div className="w-100">
    <form id="payment-form" onSubmit={handleSubmit}>
      <div className='row'>
        <div className="pb-5 col-md-12 col-12">
          <div className='row'>
              <div className="col-md-12 mx-5 px-5 mt-5 d-flex justify-content-left">
                <h1>Upgrade Plan</h1>
              </div>
          </div>      
          <div className='row'>
              {/* BILLING TOGGLE AND TRIAL CHECKBOX AREA */}
              <div className="col-md-12 mx-5 px-5 d-flex flex-column align-items-center gap-3">
                <div className="radio-block">
                  <input 
                    type="radio" 
                    name="monthly" 
                    id="monthly-on" 
                    checked={showMontly} 
                    onChange={() => {
                      setShowMonthly(true);
                      // Move index from Annual down to Monthly version smoothly[cite: 8]
                      if (selectPrice === PLAN_IDS.GOLD_YEAR) setSelectPrice(PLAN_IDS.GOLD_MONTH);
                      if (selectPrice === PLAN_IDS.SILVER_PLUS_YEAR) setSelectPrice(PLAN_IDS.SILVER_PLUS_MONTH);
                    }} 
                  />
                  <label className="on-label" htmlFor="monthly-on">Monthly</label>
                  
                  <input 
                    type="radio" 
                    name="monthly" 
                    id="monthly-off" 
                    checked={!showMontly} 
                    onChange={() => {
                      setShowMonthly(false);
                      // Move index from Monthly up to Annual version smoothly[cite: 8]
                      if (selectPrice === PLAN_IDS.GOLD_MONTH) setSelectPrice(PLAN_IDS.GOLD_YEAR);
                      if (selectPrice === PLAN_IDS.SILVER_PLUS_MONTH) setSelectPrice(PLAN_IDS.SILVER_PLUS_YEAR);
                    }} 
                  />
                  <label className="off-label" htmlFor="monthly-off">Yearly</label>
                  <span className="selected" aria-hidden="true"></span>
                </div>

                {/* Dynamic Checkbox option enabling users to explicitly opt-in or opt-out of Free Trial */}
                {showTrial && (
                  <div className="form-check d-flex align-items-center mt-2" style={{ cursor: 'pointer' }}>
                    <input 
                      className="form-check-input pointer" 
                      type="checkbox" 
                      id="trial-checkbox"
                      style={{ width: '18px', height: '18px', marginRight: '8px' }}
                      checked={isTrialChecked}
                      onChange={(e) => setIsTrialChecked(e.target.checked)}
                    />
                    <label className="form-check-label pointer Text Text-fontSize--14 Text-fontWeight--500" htmlFor="trial-checkbox">
                      Include 7 days free trial before subscription activates
                    </label>
                  </div>
                )}
              </div>
              
              <div className='col-12 '>
                <div className='price-box mt-4'>
                    <div className="PricingTable is-whiteButtonText is-lightColorBackground flex-container direction-column justify-content-center align-items-center">
                        <div className="PricingTable-grid direction-row">
                          
                          {/* ======================= TAB MONTHLY ======================= */}
                          {showMontly && (
                            <>
                              {/* Silver Plus Month Card - Displays Trial or Standard variant conditionally matching Checkbox state */}
                              {(showAllPrice || selectPrice === PLAN_IDS.SILVER_PLUS_MONTH) && (
                                isTrialChecked && showTrial ? (
                                <PriceSilverPlusMonthTrial
                                  onSelect={onSelectSilverPlusMonth} 
                                  isSelected={(selectPrice === PLAN_IDS.SILVER_PLUS_MONTH)} 
                                  isRecommended={false} 
                                  updatePayment={false} 
                                  subcripbeButton={true} 
                                />
                                )
                                : (
                                  <PriceSilverPlusMonth
                                  onSelect={onSelectSilverPlusMonth} 
                                  isSelected={(selectPrice === PLAN_IDS.SILVER_PLUS_MONTH)} 
                                  isRecommended={false} 
                                  updatePayment={false} 
                                  subcripbeButton={true} 
                                />
                                )
                              )}

                              {/* Gold Month Card - Displays Trial or Standard variant conditionally matching Checkbox state */}
                              {(showAllPrice || selectPrice === PLAN_IDS.GOLD_MONTH) && (
                                isTrialChecked && showTrial ? (
                                  <PriceGoldMonthTrial 
                                    onSelect={onSelectGoldMonth} 
                                    isSelected={(selectPrice === PLAN_IDS.GOLD_MONTH)} 
                                    isRecommended={true} 
                                    updatePayment={true} 
                                    subcripbeButton={true} 
                                  />
                                ) : (
                                  <PriceGoldMonth 
                                    onSelect={onSelectGoldMonth} 
                                    isSelected={(selectPrice === PLAN_IDS.GOLD_MONTH)} 
                                    isRecommended={true} 
                                    updatePayment={false} 
                                    subcripbeButton={true} 
                                  />
                                )
                              )}
                            </>
                          )}

                          {/* ======================= TAB YEARLY ======================= */}
                          {!showMontly && (
                            <>
                              {/* Silver Plus Year */}
                              {(showAllPrice || selectPrice === PLAN_IDS.SILVER_PLUS_YEAR) && (
                                isTrialChecked && showTrial ? (
                                  <PriceSilverPlusYearTrial 
                                    onSelect={onSelectSilverPlusYear} 
                                    isSelected={(selectPrice === PLAN_IDS.SILVER_PLUS_YEAR)} 
                                    isRecommended={false} 
                                    updatePayment={false} 
                                    subcripbeButton={true}  
                                  />
                                 )
                                :
                                (
                                  <PriceSilverPlusYear 
                                    onSelect={onSelectSilverPlusYear} 
                                    isSelected={(selectPrice === PLAN_IDS.SILVER_PLUS_YEAR)} 
                                    isRecommended={false} 
                                    updatePayment={false} 
                                    subcripbeButton={true}  
                                  />
                                )
                              )}

                              {/* Gold Year Card - Displays Trial or Standard variant conditionally matching Checkbox state */}
                              {(showAllPrice || selectPrice === PLAN_IDS.GOLD_YEAR) && (
                                isTrialChecked && showTrial ? (
                                  <PriceGoldYearTrial 
                                    onSelect={onSelectGoldYear} 
                                    isSelected={(selectPrice === PLAN_IDS.GOLD_YEAR)} 
                                    isRecommended={true} 
                                    updatePayment={true} 
                                    subcripbeButton={true} 
                                  />
                                ) : (
                                  <PriceGoldYear 
                                    onSelect={onSelectGoldYear} 
                                    isSelected={(selectPrice === PLAN_IDS.GOLD_YEAR)} 
                                    isRecommended={true} 
                                    updatePayment={false} 
                                    subcripbeButton={true} 
                                  />
                                )
                              )} 
                            </>
                          )}

                        </div>
                    </div>
              </div>
            </div>
          </div>
        </div>
        <style scoped>{`
          #payment-form { overflow: auto; }
          .pointer { cursor: pointer; }
        `}</style>
      </div>
    </form>   
    </div>
  );
}

export default UpgradePlan;